import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';

export interface AgingReportData {
  outstanding: string;
  notDue: string;
  due: string;
  due1To30Days: string;
  due31To60Days: string;
  due61To90Days: string;
  due90PlusDays: string;
}

@Component({
  selector: 'app-aging-report',
  imports: [MatButtonModule, MatTableModule],
  templateUrl: './aging-report.component.html',
  styleUrl: './aging-report.component.scss',
})
export class AgingReportComponent implements OnInit, OnDestroy {
  constructor(
    public dialogRef: MatDialogRef<AgingReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.data = data;
  }

  ngOnInit(): void {
    return;
  }

  ngOnDestroy(): void {
    this.onClose();
    return;
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
